var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"float-window",style:({
    left: `${_vm.left}px`,
    top: `${_vm.top}px`,
    width: `${_vm.width}px`,
    height: `${_vm.height}px`
}),on:{"mouseover":_vm.clearFdAd,"mouseout":_vm.starFdAd}},[_c('div',{staticClass:"float-window-close",on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-circle-close",staticStyle:{"font-size":"20px","color":"#ffffff"}})]),_c('div',{on:{"click":_vm.baywindowsViewDetails}},[_c('img',{attrs:{"src":_vm.image,"bayid":_vm.bayid,"bayzd":_vm.bayzd,"baytype":_vm.baytype,"alt":""},on:{"dragstart":function($event){$event.preventDefault();}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }